<div class="modal" id="confirmModal" tabindex="1" aria-labelledby="confirmModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="confirmModalLabel">{{ confirmModalTitle }}</h5>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
            </div>
            <div class="modal-body">
                <p id="confirmationMessage"></p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary rounded-pill" data-bs-dismiss="modal"
                    (click)="confirmAction(false)">Cancel</button>
                <button type="button" class="btn btn-primary rounded-pill" id="confirmOkButton"
                    (click)="confirmAction(true)">{{ confirmOkText }}</button>
            </div>
        </div>
    </div>
</div>